import { getAlpha2Codes } from 'i18n-iso-countries';
import { ApiCountryCode } from '../openapi';
import { difference } from 'lodash-es';

export const ALL_COUNTRY_CODES = Object.keys(getAlpha2Codes()) as ApiCountryCode[];

const BANK_TRANSFER_BLACKLIST = __BRIGHTY__ || __WOLFO__ ? ['RU', 'BY'] : [];
export const BANK_TRANSFER_COUNTRY_CODES = difference(
  ALL_COUNTRY_CODES,
  BANK_TRANSFER_BLACKLIST,
) as ApiCountryCode[];
